<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()
</script>

<template>
  <div :class="cn('flex justify-between flex-row gap-y-1.5 p-6 pb-0', props.class)">
    <slot />
  </div>
</template>
